import { Box, CircularProgress } from "@mui/material";
import React from "react";

export default function CircularLoader({ height = "50vh" }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height={height}
      width="100%"
    >
      <CircularProgress />
    </Box>
  );
}
